import { render } from "./DataMonitoringEntries.vue?vue&type=template&id=20087394"
import script from "./DataMonitoringEntries.vue?vue&type=script&lang=js"
export * from "./DataMonitoringEntries.vue?vue&type=script&lang=js"

import "./DataMonitoringEntries.vue?vue&type=style&index=0&id=20087394&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__